import {Component, OnInit, ViewChild} from '@angular/core';
import {Subscription} from "rxjs";
import {AoListComponent} from "../../widgets/ao-list/ao-list.component";
import {MissionService} from "../../mission.service";
import {FirstAOInternServicesService} from "../../api/gen/services/first-aointern-services.service";
import { MatDialog } from "@angular/material/dialog";
import {NoticeFacade} from "../../api/gen/models/notice-facade";

@Component({
  selector: 'app-private-redaction',
  templateUrl: './private-redaction.component.html',
  styleUrls: ['./private-redaction.component.css']
})
export class PrivateRedactionComponent implements OnInit {

    subscription: Subscription;
    currentNoticeId = null;

    @ViewChild(AoListComponent)
    private aoList: AoListComponent;

    opened = true;

    constructor(private missionService: MissionService,
                private firstAOInternServicesService: FirstAOInternServicesService,
                public dialog: MatDialog) {
        this.subscription = missionService.currentNoticeId$.subscribe(
            value => {
                this.currentNoticeId = value;
            });
    }

    ngOnInit() {
    }

    changePagination(event) {
        this.missionService.changePagination(event.pageSize, event.pageIndex, true);
    }

    addNewPrivateAO() {
        const param: NoticeFacade = {
            titre: "Nouvel Appel d'Offres",
            typeAo: "private",
            familleAvis: "fns"
        };

        this.firstAOInternServicesService.editorAddNotice(param).subscribe(value => {
            this.currentNoticeId = value.aoId;
            this.aoList.reloadNoticesAndOpenNotice(this.currentNoticeId);
        });
    }

    ngOnDestroy() {
        // prevent memory leak when component destroyed
        this.subscription.unsubscribe();
    }

}
